export default [
  {
    id: "1",
    name: 'Apple'
  },
  {
    id: "2",
    name: 'Samsung'
  },
  {
    id: "3",
    name: 'Htc'
  },
  {
    id: "4",
    name: 'Lenovo'
  },
  {
    id: "5",
    name: 'Microsoft'
  }
]



// WEBPACK FOOTER //
// ./src/~/api/mockCategories.js